import React from 'react';
export const Seven = () => (React.createElement("svg", { width: "28", height: "40", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M3.4 40h11L28 6V0H.6L0 12.3h1.1L3 7.5h23v.3z", fillRule: "evenodd" })));
